import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/JWTAuthContext';

const ProtectedRoute = ({ children, fallback = null }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!user) {
    if (fallback) {
      return fallback;
    }
    
    // Redirect to login using React Router
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
